module.exports = __webpack_public_path__ + "static/media/consultorioMedico.ca68ef9c.jpg";